export default "__VITE_PUBLIC_ASSET__c78d5856__"